import { Reveal, SectionHeading } from "./Reveal";
import { Lightbulb } from "lucide-react";

export const VisitorGuide = ({ guide = [], onEnquire }) => (
  <section id="visitor-guide" className="bg-[#0A192F] py-20 md:py-28 relative overflow-hidden" data-testid="visitor-guide-section">
    <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#C5A059]/8 blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14 items-start">
        <div className="lg:sticky lg:top-28">
          <SectionHeading eyebrow="Plan Your Visit" title="The Eufaula Visitor Guide" dark testId="guide" />
          <Reveal delay={0.15}>
            <p className="text-[#F8F6F0]/70 mt-6 leading-relaxed text-sm sm:text-base">
              A perfect day in Eufaula, curated by our front desk. Follow the chapters below — or call us and we will build an itinerary around your stay.
            </p>
            <button
              onClick={() => onEnquire("")}
              className="mt-8 bg-[#C5A059] text-[#0A192F] hover:bg-[#D4AF37] px-7 py-3.5 rounded-full font-semibold shadow-md transition-all"
              data-testid="guide-plan-stay-button"
            >
              Plan My Stay
            </button>
          </Reveal>
        </div>

        <div className="space-y-0">
          {guide.map((g, i) => (
            <Reveal key={g.id || g.title} delay={i * 0.08}>
              <div className="border-b border-[#F8F6F0]/10 py-8 flex gap-6 group" data-testid={`guide-item-${g.id || i}`}>
                <span className="font-serif-display text-4xl font-bold text-[#C5A059]/40 group-hover:text-[#C5A059] transition-colors duration-500 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-serif-display text-2xl font-semibold text-[#F8F6F0]">{g.title}</h3>
                  <p className="text-[#F8F6F0]/65 text-sm leading-relaxed mt-2">{g.description}</p>
                  {g.tips && (
                    <p className="mt-3 text-xs text-[#C5A059] flex items-start gap-2 bg-[#C5A059]/10 border border-[#C5A059]/20 rounded-xl px-4 py-2.5">
                      <Lightbulb size={14} className="shrink-0 mt-0.5" /> {g.tips}
                    </p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
